module.exports = __webpack_public_path__ + "img/building-img-color2.20fe3a09.png";